(function () {
  if (window.__inkyboxCartGuardInstalled || !window.fetch) return;
  window.__inkyboxCartGuardInstalled = true;

  const originalFetch = window.fetch.bind(window);
  let cartWriteQueue = Promise.resolve();
  let cartJsonRequest = null;
  let lastCartJsonText = '';

  const EMPTY_CART_JSON = JSON.stringify({
    token: '',
    note: null,
    attributes: {},
    original_total_price: 0,
    total_price: 0,
    total_discount: 0,
    total_weight: 0,
    item_count: 0,
    items: [],
    requires_shipping: false,
    currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
    items_subtotal_price: 0,
    cart_level_discount_applications: []
  });

  function getUrl(input) {
    const raw = typeof input === 'string' ? input : input && input.url ? input.url : '';
    try {
      return new URL(raw, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function getMethod(input, init) {
    return String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
  }

  function isSameOriginCartRequest(url) {
    if (!url || url.origin !== window.location.origin) return false;
    return url.pathname === '/cart' || url.pathname === '/cart.js' || url.pathname.indexOf('/cart/') === 0;
  }

  function isCartWrite(url, method) {
    if (!isSameOriginCartRequest(url)) return false;
    if (method === 'GET' || method === 'HEAD') return false;
    return ['/cart/add.js', '/cart/change.js', '/cart/update.js', '/cart/clear.js', '/cart/add', '/cart/change', '/cart/update', '/cart/clear'].includes(url.pathname);
  }

  function isCartJsonRead(url, method) {
    return isSameOriginCartRequest(url) && method === 'GET' && url.pathname === '/cart.js';
  }

  function isCartSectionsRead(url, method) {
    return isSameOriginCartRequest(url) && method === 'GET' && url.pathname === '/cart' && url.searchParams.has('sections');
  }

  function isProbablyJson(text) {
    const trimmed = String(text || '').trim();
    return trimmed.startsWith('{') || trimmed.startsWith('[');
  }

  function makeJsonResponse(text, status) {
    return new Response(text, {
      status: status || 200,
      statusText: 'OK',
      headers: { 'Content-Type': 'application/json; charset=utf-8', 'X-Inkybox-Cart-Guard': '1' }
    });
  }

  async function fetchAsReusableResponse(input, init, url) {
    const response = await originalFetch(input, init);
    const text = await response.clone().text().catch(() => '');
    const headers = new Headers(response.headers);

    if (response.ok && isProbablyJson(text) && url && url.pathname === '/cart.js') {
      lastCartJsonText = text;
      window.__inkyboxLastCartJsonText = text;
    }

    return new Response(text, { status: response.status, statusText: response.statusText, headers });
  }

  window.InkyboxCartGuard = window.InkyboxCartGuard || {};

  window.InkyboxCartGuard.fetchCartJson = async function () {
    const response = await window.fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    const text = await response.text();
    if (!response.ok || !isProbablyJson(text)) return JSON.parse(lastCartJsonText || window.__inkyboxLastCartJsonText || EMPTY_CART_JSON);
    try {
      return JSON.parse(text);
    } catch (error) {
      return JSON.parse(lastCartJsonText || window.__inkyboxLastCartJsonText || EMPTY_CART_JSON);
    }
  };

  window.InkyboxCartGuard.fetchCartSections = async function (sectionIds) {
    const ids = Array.isArray(sectionIds) ? sectionIds.filter(Boolean) : [];
    if (!ids.length) return {};
    const response = await window.fetch('/cart?sections=' + encodeURIComponent(ids.join(',')), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    const text = await response.text();
    if (!response.ok || !isProbablyJson(text)) return {};
    try {
      return JSON.parse(text);
    } catch (error) {
      return {};
    }
  };

  window.fetch = function (input, init) {
    const url = getUrl(input);
    const method = getMethod(input, init);

    if (!isSameOriginCartRequest(url)) return originalFetch(input, init);

    if (isCartJsonRead(url, method)) {
      if (!cartJsonRequest) {
        cartJsonRequest = fetchAsReusableResponse(input, init, url)
          .then((response) => response.clone().text())
          .then((text) => {
            if (isProbablyJson(text)) {
              lastCartJsonText = text;
              window.__inkyboxLastCartJsonText = text;
              return text;
            }
            return lastCartJsonText || window.__inkyboxLastCartJsonText || EMPTY_CART_JSON;
          })
          .catch(() => lastCartJsonText || window.__inkyboxLastCartJsonText || EMPTY_CART_JSON)
          .finally(() => window.setTimeout(() => { cartJsonRequest = null; }, 80));
      }
      return cartJsonRequest.then((text) => makeJsonResponse(text, 200));
    }

    if (isCartSectionsRead(url, method)) {
      return originalFetch(input, init)
        .then(async (response) => {
          const text = await response.clone().text().catch(() => '');
          if (response.ok && isProbablyJson(text)) {
            return new Response(text, { status: response.status, statusText: response.statusText, headers: response.headers });
          }
          return makeJsonResponse('{}', 200);
        })
        .catch(() => makeJsonResponse('{}', 200));
    }

    if (isCartWrite(url, method)) {
      const run = cartWriteQueue.catch(() => {}).then(() => {
        document.documentElement.classList.add('inkybox-cart-updating');
        return originalFetch(input, init).finally(() => {
          window.setTimeout(() => {
            const lockUntil = Number(window.__inkyboxCartUiLockedUntil || 0);
            if (!window.__inkyboxCartUiBusy && Date.now() >= lockUntil) {
              document.documentElement.classList.remove('inkybox-cart-updating');
            }
          }, 220);
        });
      });
      cartWriteQueue = run.then(() => {}, () => {});
      return run;
    }

    return originalFetch(input, init);
  };
})();
